<template>
	<div class="mb-4 mt-1">
		<a class="pl-3 text-body-2 text-decoration-underline cursor-pointer text-primary" @click="openAddressLookup">
			Use your location to find or create a project
		</a>
	</div>
</template>

<script>
	export default {
		name: "AddressLookupLink",
		methods: {
			openAddressLookup() {
				this.$emit("openAddressLookup");
			}
		}
	};
</script>
